module.exports = {"320804001":"长江路街道","320804002":"王家营街道","320804003":"新渡口街道","320804004":"古清口街道","320804103":"南陈集镇","320804107":"丁集镇","320804109":"徐溜镇","320804110":"渔沟镇","320804113":"三树镇","320804114":"高家堰镇","320804115":"马头镇","320804116":"刘老庄镇","320804117":"淮高镇","320804400":"淮安高新技术产业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320804.json
// module id = 895
// module chunks = 0